var $a = jQuery.noConflict();
$a(document).ready(function() {
var pathCheck =  window.location.pathname;
var searchpath =  window.location.search;
  
  

  
  $a('#product-photo-thumbs > li:eq(0)').addClass('submenu-active');
  
  $a(function(){
    
   $a('#product-photo-thumbs > li').click(function(){
      var item=$(this).parent();
       $a('#product-photo-thumbs > li').removeClass('submenu-active');
       item.addClass("submenu-active")
    });
       
});
  
  
/* Start Product Page */
if(pathCheck.match('/pages'))
	{
    var page_title = $a('.page-title').html();
    $a('.content-main').before('<div class="page-top-banner"><div class="top-page-title">'+page_title+'</div></div>');
    
    
    var page_breadcumb = $a('#breadcrumbs').html();
    $a('.top-page-title').after('<div class="page-top-breadcumb">'+page_breadcumb+'</div>');
    
	}
		
});